<template>
  <div class="intro">
    <transition appear name="fade">
    <div class="container">
      <div class="row">
        <div class="entry">
          <h1 class="title">De vervreemdingsprocedure
    voor cultuurgoederen</h1>

          <div class="content">
            <p>Het Rijk, provincies, gemeenten en andere publiekrechtelijke rechtspersonen zoals universiteiten en waterschappen zijn eigenaar van cultuurgoederen. Een deel van deze cultuurgoederen wordt namens deze rechtspersonen beheerd door museale instellingen. Reorganisaties, verhuizingen en fusies van overheidsorganisaties of het opstellen van een nieuw collectieplan kunnen in de praktijk aanleiding zijn om bepaalde cultuurgoederen te vervreemden. Onderdeel van goed collectiebeleid is een zorgvuldige en transparante wijze van vervreemden van voorwerpen uit deze collecties. De Erfgoedwet stelt kaders aan deze vervreemdingsprocedure voor cultuurgoederen in publiek bezit. Op deze manier wordt voorkomen dat waardevolle cultuurgoederen ongemerkt verdwijnen uit het publieke domein. In dit stappenplan leest u hoe deze procedure in de praktijk werkt en wat dit voor u betekent. Musea die geregistreerd zijn in het Museumregister én die cultuurgoederen in beheer of eigendom hebben, volgen ook de procedure zoals beschreven in de <a href="https://museumvereniging.nl/lamo-leidraad-afstoten-museale-objecten" target="_blank">LAMO</a> (Leidraad voor Afstoting van Museale Objecten van de Museumvereniging).</p>
          </div>

          <Button theme="white">
            <router-link to="/overheidsorganisatie-of-museum">Start</router-link>
          </Button>
        </div>

        <div class="media">
          <figure class="figure">
            <img
              class="frame"
              :src="require('@/assets/images/video-frame.png')"
              alt=""
              draggable="false"
            />
            <svg
              class="play"
              @click="showModal = true"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 69.49 69.49"
            >
              <circle
                cx="34.75"
                cy="34.75"
                r="34.75"
                fill="#fff"
              />
              <path d="M22.3 18.64v32.21l34.81-16.1L22.3 18.64z"/>
            </svg>
          </figure>
          <Modal
            v-if="showModal"
            @close="showModal = false"
            video
          >
            <video
              :src="require('@/assets/video/web-hd.mp4')"
              class="video"
              slot="video"
              ref="video"
              :poster="require('@/assets/video/poster.jpg')"
              controls
              autoplay
              ></video>
          </Modal>
          <div class="description">
            <div class="circle left-top"></div>
            <div class="circle left-bottom"></div>
            <div class="circle right-top"></div>
            <div class="circle right-bottom"></div>
            <p>
              Animatie over de vervreemdingsprocedure
            </p>
          </div>
        </div>
      </div>
    </div>
  </transition>
  </div>
</template>

<script>
import Button from '@/components/Button'
import Modal from '@/components/Modal'

export default {
  name: 'Intro',
  components: {
    Button,
    Modal
  },
  data () {
    return {
      showModal: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .intro {
    overflow: hidden;
  }
  .container {
    @extend %container;
    padding-top: 70px;
    padding-bottom: 70px;

    @media (max-width: 1381px) {
      padding-top: 46px;
      padding-bottom: 46px;
    }
  }
  .row {
    @extend %row;
  }
  .entry {
    @extend %col-md-7;
  }
  .title {
    margin-top: 0;
  }
  .media {
    @extend %col-md-5;

    @media (max-width: 991px) {
      margin-top: 20px;
    }
  }
  .figure {
    position: relative;
    max-width: 530px;

    @media (min-width: 992px) {
      margin-top: 50px;
    }
  }
  .description {
    margin-top: 17px;
    margin-left: 11px;
    display: block;
    color: #073a60;
    background-color: #ffe9b7;
    font-size: 18px;
    line-height: 21px;
    border-bottom: 7px solid #eaa00a;
    position: relative;
    max-width: 214px;
    padding: 11px 17px;

    p {
      margin: 0;
    }
  }
  .circle {
    background-color: #eaa00a;
    height: 6px;
    width: 6px;
    border-radius: 50%;
    position: absolute;
  }
  .left-top {
    left: 3.5px;
    top: 3.5px;
  }
  .left-bottom {
    left: 3.5px;
    bottom: 3.5px;
  }
  .right-top {
    top: 3.5px;
    right: 3.5px;
  }
  .right-bottom {
    right: 3.5px;
    bottom: 3.5px;
  }
  .frame {
    max-width: 530px;
  }
  .play {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 2;
    cursor: pointer;
    width: 69px;
    height: 69px;
  }
  .video {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/domains/Intro.vue